module.exports = __webpack_public_path__ + "static/media/arm.147fb328.svg";